import { ApplicationConfig, provideAppInitializer } from '@angular/core'
import { Overlay } from '@angular/cdk/overlay'
import { HttpClient, provideHttpClient, withInterceptors, withXhr } from '@angular/common/http'
import { provideRouter } from '@angular/router'
import { provideSignalFormsConfig } from '@angular/forms/signals'
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core'
import { provideStore } from '@ngrx/store'

import { environment } from '@env'
import { routes } from './app.routes'
import { extProviders } from './ngrx-devtools'

import { httpInterceptors } from '@core/requests/interceptors'
import { MessageService } from '@shared/modules/primeng-clone/api'

import { HttpLoaderFactory } from '@core/i18n/http-loader.factory'
import { Locale } from '@core/i18n/locale.enum'

import { AuthApi } from '@core/authentication/auth/auth.api'
import { OidcService } from '@core/authentication/oidc/oidc.service'
import { OidcFactory } from '@core/authentication/oidc/oidc.factory'
import { idsInitializer } from '@core/authentication/oidc/ids.factory'
import { FACTORY_TOKEN_OIDC, DEBUG_TOKEN_OIDC } from '@core/authentication/oidc/oidc.constants'

import { I18nApi } from '@core/i18n/i18n.api'
import { initTranslateModule } from '@core/i18n/i18n.factory'

import { DownloadService } from '@shared/services/download/download.service'

import { REDUCER_TOKEN, getReducers, metaReducers } from '@core/store/store.config'

export const appConfig: ApplicationConfig = {
  providers: [
    Overlay,
    // Signal Forms ([formField]) does not add the legacy ng-* status classes that
    // NgControlStatus applies to Reactive Forms inputs; the app's global form styles
    // (error messages visibility, red borders) target exactly those classes
    provideSignalFormsConfig({
      classes: {
        'ng-dirty': (field) => field.state().dirty(),
        'ng-touched': (field) => field.state().touched(),
        'ng-invalid': (field) => field.state().invalid(),
        'ng-valid': (field) => field.state().valid(),
      },
    }),
    provideHttpClient(withXhr(), withInterceptors(httpInterceptors)),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      lang: Locale.Es,
    }),
    provideRouter(routes),
    MessageService,
    provideAppInitializer(idsInitializer),
    provideAppInitializer(initTranslateModule),
    AuthApi,
    OidcService,
    { provide: FACTORY_TOKEN_OIDC, useFactory: OidcFactory },
    { provide: DEBUG_TOKEN_OIDC, useValue: !environment.production },
    I18nApi,
    DownloadService,
    { provide: REDUCER_TOKEN, useFactory: getReducers },
    provideStore(REDUCER_TOKEN, { metaReducers }),
    ...extProviders,
  ],
}
